import { render, staticRenderFns } from "./VersionPage.vue?vue&type=template&id=34a7a994&scoped=true&"
import script from "./VersionPage.vue?vue&type=script&lang=js&"
export * from "./VersionPage.vue?vue&type=script&lang=js&"
import style0 from "./VersionPage.vue?vue&type=style&index=0&id=34a7a994&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a7a994",
  null
  
)

export default component.exports